import React, { FunctionComponent, useMemo } from 'react';

import { Campaign } from '@shared/types/mylounge';
import { TWENTY_FOUR_HOURS_IN_MILLISECONDS } from '@client/config/constants';
import { SpecialCountdown } from '@client/components/shared/Shared';
import { TimeLeft } from '@client/components/shared/timeLeft';
import { useVariant } from '@client/lib/assignments';

import Discount from './discount';
import { CategorySubline } from '../category-subline';
import * as S from './campaign-info.styles';

interface Props {
    campaign: Campaign;
    categorySubline: string[];
    isCampaignTitleExperiment: boolean;
}

export const CampaignInfo: FunctionComponent<Props> = ({
    campaign,
    categorySubline,
    isCampaignTitleExperiment,
}) => {
    const thresholdForSpecialTimer = Date.now() + TWENTY_FOUR_HOURS_IN_MILLISECONDS;

    const dateEnd = useMemo(() => new Date(campaign.endsAt).getTime(), [campaign.endsAt]);
    const isSpecialTimer =
        campaign.options && campaign.options.specialTimer && dateEnd <= thresholdForSpecialTimer;

    const isHideCgExperiment = useVariant(
        'e5b89011-ae1c-47d3-86b6-ddc5df96fb89',
        'variant_categorieshidden',
    );

    return (
        <S.Container
            isHideCgExperiment={isHideCgExperiment}
            isCampaignTitleExperiment={isCampaignTitleExperiment}
        >
            <S.Wrapper>
                {isSpecialTimer ? (
                    <SpecialCountdown dateTill={dateEnd} />
                ) : (
                    <S.RegularContainer isCampaignTitleExperiment={isCampaignTitleExperiment}>
                        <S.InfoWrapper isHideCgExperiment={isHideCgExperiment}>
                            <S.Title isCampaignTitleExperiment={isCampaignTitleExperiment}>
                                {campaign.name}
                            </S.Title>
                            {!isHideCgExperiment && (
                                <CategorySubline categorySubline={categorySubline} />
                            )}
                        </S.InfoWrapper>
                        <S.RegularTextContainer>
                            <TimeLeft dateTill={dateEnd} />
                            <Discount campaign={campaign} />
                        </S.RegularTextContainer>
                    </S.RegularContainer>
                )}
            </S.Wrapper>
        </S.Container>
    );
};

export default CampaignInfo;
